import { CreationOverlay } from "../misc/CreationOverlay";
import { DialogHeader, DialogTitle } from "@/components/ui/dialog";

import type { Tag } from "../types";
import { TagForm } from "./TagForm";

type TagDialogProps = {
  open: boolean;
  tag?: Pick<Tag, "name" | "color">;
  title: string;
  onSubmit(tag: Pick<Tag, "name" | "color">): Promise<void>;
  onClose(): void;
};

export function TagDialog({
  open,
  tag,
  title,
  onClose,
  onSubmit,
}: TagDialogProps) {
  const handleClose = (isOpen = false) => {
    if (!isOpen) {
      onClose();
    }
  };

  const handleSubmit = async (data: Pick<Tag, "name" | "color">) => {
    await onSubmit(data);
    handleClose();
  };

  return (
    <CreationOverlay open={open} onOpenChange={handleClose}>
      <div className="min-h-0 overflow-y-auto p-4">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <TagForm open={open} tag={tag} onSubmit={handleSubmit} />
      </div>
    </CreationOverlay>
  );
}
